module.exports = __webpack_public_path__ + "8ee28ea96386f570f2f42af873b89e9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/no-data.svg
// module id = 689
// module chunks = 0